import { render, staticRenderFns } from "./addBankNo.vue?vue&type=template&id=bc2436ce&scoped=true&"
import script from "./addBankNo.vue?vue&type=script&lang=js&"
export * from "./addBankNo.vue?vue&type=script&lang=js&"
import style0 from "./addBankNo.vue?vue&type=style&index=0&id=bc2436ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2436ce",
  null
  
)

export default component.exports